// extracted by mini-css-extract-plugin
export var boldText = "WeCoc";